import { compose, withProps } from 'recompose';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import styles from '../index.styl';

import {
  membersCountSelector,
  membersListSelector,
  moderatorsCountSelector,
  moderatorsListSelector,
} from '../selectors';
import { currentCommunityIdSelector } from '../../../../redux/communities/selectors/selectors';
import { actions as membersActions } from '../../../../redux/communities/communityMembers';
import { actions as moderatorsActions } from '../../../../redux/communities/communityModerators';
import { COMMUNITIES_USER_ROLES } from '../../../../constants';

const mapDispatchToProps = dispatch => {
  return {
    fetchMoreMembers: communityId =>
      dispatch(membersActions.getOlderMembers({ communityId })),
    fetchMoreModerators: communityId =>
      dispatch(moderatorsActions.getOlderModerators({ communityId })),
  };
};

const mapStateToProps = state => ({
  membersList: membersListSelector(state),
  moderatorsList: moderatorsListSelector(state),
  communityId: currentCommunityIdSelector(state),
  membersCount: membersCountSelector(state),
  moderatorsCount: moderatorsCountSelector(state),
});

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(
    ({
      membersList,
      moderatorsList,
      membersCount,
      moderatorsCount,
      listType,
    }) => {
      return {
        isListTypeMembers: listType === COMMUNITIES_USER_ROLES.MEMBER,
        shouldLoadMoreMembers: Boolean(
          membersList.length && membersCount > membersList.length,
        ),
        shouldLoadMoreModerators: Boolean(
          moderatorsList.length && moderatorsCount > moderatorsList.length,
        ),
      };
    },
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Community/About/FullList/enhance.js